import { Button } from '@components/button/Button';
import { useState } from 'react';
import { useMaintenanceInfo } from '@data/maintenance/maintenanceActions';
import { WorkspaceSwitchPrompt } from '@features/workspace-switch/WorkspaceSwitchPrompt';
import { useI18nContext } from '../../i18n/i18n-react';
import { useAuth } from '../../providers/AuthProvider';

export function MaintenanceMessage() {
    const { LL } = useI18nContext();
    const { tenant } = useAuth();
    const maintenanceInfo = useMaintenanceInfo(tenant);
    const [isRefetching, setIsRefetching] = useState(false);

    return (
        <div className="global-error">
            <div className="global-error-content">
                <h2>{LL.MAINTENANCE_MODE_CURRENTLY_ENABLED()}</h2>
                <p>{LL.CONTACT_ADMIN_FOR_INFO()}</p>
                <Button
                    title={LL.RETRY()}
                    loading={isRefetching}
                    onClick={async () => {
                        setIsRefetching(true);
                        await maintenanceInfo.refetch({ throwOnError: false });
                        setIsRefetching(false);
                    }}
                    style={{ marginTop: '1em' }}
                />
                <WorkspaceSwitchPrompt />
            </div>
        </div>
    );
}
